import { cm } from '~/utils/utils'

export interface CampaignErrorBlockProps {
  text?: BlockText | null
  fields?: {
    align?: 'center' | 'left' | 'right'
  }
}

export function CampaignErrorBlock({ text, fields }: CampaignErrorBlockProps) {
  const value = text?.text || ''
  const align = fields?.align || 'left'
  return (
    <div className={cm('mt-4 text-gray-500 mb-5', `text-${align}`)}>
      <div className='border border-[#f5d7d3] rounded inline-block px-2 py-1 bg-[#faebe9ee] text-[#ce3b25]'>
        {value}
      </div>
    </div>
  )
}
